<template>
  <!-- najnovije cene na pijacama (vrh pocetne): logika klizaca je u ScrollSlider, izgled u assets/scss/marketPriceCard.scss -->
  <ScrollSlider
    :items="prices"
    :title="title"
    title-class="section-title mb-4"
    :item-key="getProductKey"
    :item-class="(product) => ['swiper-product-width market-price-slide', { 'market-price-slide-wide': getCitiesCount(product) > 10 }]"
    body-class="swiper-products market-prices-slider"
    track-class="market-prices-track"
    :btn-prev-class="['swiper-button-prev-tc-most', btn_prev]"
    :btn-next-class="['swiper-button-next-tc-most', btn_next]"
    :dots-class="['mt-4 swiper-pagination-most', paginate]"
    hide-edge-arrows
  >
    <template #header>
      <div v-if="week?.week" class="week-info">
        <div class="week-info-content">
          <span class="week-info-label">Cene važe za nedelju</span>
          <strong class="week-info-value">od {{ week.week }}</strong>
        </div>
      </div>
    </template>

    <template #item="{ item }">
      <MarketPriceCard :product="item" />
    </template>

    <template #empty>
      <div class="empty-prices">Trenutno nema dostupnih cena.</div>
    </template>
  </ScrollSlider>
</template>

<script setup>
import ScrollSlider from '~/components/widgets/Slider/ScrollSlider.vue'
import MarketPriceCard from '~/components/widgets/Stips/MarketPriceCard.vue'

const props = defineProps({
  prices: { type: Array, default: () => [] },
  week: { type: Object, default: () => ({}) },
  title: { type: String, default: 'Najnovije cene na pijacama' },

  paginate: { type: String, default: 'swiper-pagination' },
  btn_next: { type: String, default: 'swiper-button-next-tc-top' },
  btn_prev: { type: String, default: 'swiper-button-prev-tc-top' },
})

const getProductKey = (product, index) =>
  product.id ?? product.Proizvod ?? product.product ?? `market-price-${index}`

// kartica sa vise od 10 gradova je siroka (market-price-slide-wide)
const skipPriceKeys = ['Proizvod', 'Jedinica mere', 'Rasa', 'Težina', 'Godina']

const getCitiesCount = (product) =>
  Object.entries(product).filter(([key, value]) => !skipPriceKeys.includes(key) && value !== null && value !== '').length
</script>
